(function() {
  
  var regionLocaleData = {}
  var storeData = {}
  var $locationBanner = null
  var $body = $('body')

  /**
   * Get a locally stored value
   */
  function getStoredValue(id) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.getItem(id)
    }
  }

  /**
   * Set a locally stored value
   */
  function setStoredValue(id, value) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.setItem(id, value)
    }
  }

  /**
   * Remove a locally stored value
   */
  function removeStoredValue(id) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.removeItem(id)
    }
  }

  /**
   * Extract the language from a locale string
   */
  function getLanguage(localeString) {
    return (localeString.indexOf('-') > -1) ? localeString.substring(0, localeString.indexOf('-')) : localeString
  }

  /**
   * Find if a locale or language exists in an array of locales
   */
  function findLocaleOrLanguage(locale, language, arr) {
    var foundLocale = false
    var foundLanguage = false

    for (var i=0, len=arr.length; i<len; i++) {
      var localeObj = arr[i]
      if (!foundLocale){
        if (localeObj.locale.toLowerCase() == locale.toLowerCase()) {
          foundLocale = localeObj
        }
      }
      if (!foundLanguage){
        if (localeObj.language.toLowerCase() == language.toLowerCase()) {
          foundLanguage = localeObj
        }
      }
    }

    return (foundLocale) ? foundLocale : foundLanguage
  }

  /**
   * Check if a visitor has dismissed the banner
   */
  function hasDismissedBanner() {
    // first, allow the ability to force clear the banner dismissal
    // would be nice to have npm modules available for this
    var query = window.location.search
    var queryList = query.replace('?', '').split('&')
    for (var i=0, len=queryList.length; i<len; i++) {
      var keyVal = queryList[i].split('=')
      if (keyVal.length === 2) {
        if ((keyVal[0] === 'force_banner') && (parseInt(keyVal[1]) === 1)) {
          removeStoredValue('locationBannerDismissed')
        }
      }
    }

    return (getStoredValue('locationBannerDismissed') === 'true')
  }

  /**
   * Get country/locale suggestions for the visitor
   * @param {object} visitorData - Visitor country data
   * @returns {array} Array of suggestions (empty array means unsupported region)
   * @returns {false} False if no suggestions are necessary
   */
  function getSuggestions(visitorData) {
    var visitorCountryCode = visitorData.country.iso_code
    if (visitorCountryCode) {
      visitorCountryCode = visitorCountryCode.toLowerCase()
    }

    var visitorLocale = navigator.language ? navigator.language :
      navigator.browserLanguage ? navigator.browserLanguage : 'en'

    var visitorLanguage = getLanguage(visitorLocale)
    if (visitorLanguage) {
      visitorLanguage = visitorLanguage.toLowerCase()
    }
    
    var suggestedLocale = {}
    var suggestions = []

    // logic for Europe
    if (visitorCountryCode) {
      if (visitorData.continent.code.toLowerCase() === 'eu') {
        switch (visitorCountryCode) {
          case 'gb':
          case 'ie':
            // do nothing, these countries have their own stores
            break
          case 'de':
            // suggest the .eu store with the visitor's locale
            visitorCountryCode = 'eu'
            visitorLanguage = 'de'
            break
          case 'es':
            visitorCountryCode = 'eu'
            visitorLanguage = 'es'
            break
          case 'nl':
            // suggest the .eu store with the NL visitor's locale
            visitorCountryCode = 'eu'
            visitorLanguage = 'nl'
            break
          default:
            // suggest the .eu store with the English locale
            visitorCountryCode = 'eu'
            visitorLanguage = 'en'
            break
        }
      }
    }

    if (visitorCountryCode === storeData.countryCode) {
      // same country
      if (visitorLanguage === storeData.language) {
        // same language, it's probably fine
        return false
      } else {
        // different language
        if (regionLocaleData[visitorCountryCode]) {
          suggestedLocale = findLocaleOrLanguage(visitorLocale, visitorLanguage, regionLocaleData[visitorCountryCode])
          if (suggestedLocale) {
            suggestedLocale.default = true
            suggestions = regionLocaleData[visitorCountryCode]
          } else {
            // no locale or language suggestions
            return false
          }
        } else {
          // no locale data for country
          return false
        }
      }
    } else if (regionLocaleData[visitorCountryCode]) {
      // different supported country
      suggestions = regionLocaleData[visitorCountryCode]
      suggestedLocale = findLocaleOrLanguage(visitorLocale, visitorLanguage, regionLocaleData[visitorCountryCode])
      if (suggestedLocale) {
        suggestedLocale.default = true
      }

    } else {
      // unsupported country
      return []
    }

    return suggestions
  }

  /**
   * Display the suggestions
   */
  function showSuggestions(suggestions) {

    var $locationSelect = $locationBanner.find('.location-banner__country-select select')
    var $optionTemplate = $locationSelect.find('option').remove()
    var options = []
    var hasSelected = false

    for (var i=0,len=suggestions.length; i<len; i++) {
      var $newOption = $optionTemplate.clone()
      var suggestion = suggestions[i]

      $newOption.attr('value', suggestion.href)
      $newOption.html(suggestion.label)
      if (suggestion.default) {
      
        $newOption.prop('selected', true)
        $locationBanner.find('.location-banner__continue-button').attr('href', suggestion.href)
        hasSelected = true
      }

      options.push($newOption)
    }

    if (options.length && !hasSelected) {
      options[0].prop('selected', true)
      $locationBanner.find('.location-banner__continue-button').attr('href', options[0].attr('href'))
    }

    $locationSelect.append(options)

    $locationSelect.on('change', changeSelection)

    $locationBanner.find('.location-banner__country-select').removeClass('hide')
    showBanner()

  }

  /**
   * Display the unsupported region message
   */
  function showUnsupported() {
    $locationBanner.find('.location-banner__unsupported-region').removeClass('hide')
    showBanner()
  }

  /**
   * Show the banner
   */
  function showBanner() {
    $locationBanner.find('.location-banner__dismiss-button').on('click', dismissBanner)
    $locationBanner.removeClass('hide')
    $('body').toggleClass('locationBanner--active')
  }

  /**
   * Hide the banner
   */
  function dismissBanner() {
    $locationBanner.find('.location-banner__dismiss-button').off('click')
    $locationBanner.addClass('hide')
    setStoredValue('locationBannerDismissed', 'true')
    $('body').toggleClass('locationBanner--active')
  }

  /**
   * Change handler for the banner dropdown
   */
  function changeSelection() {
    $locationBanner.find('.location-banner__continue-button').attr('href', $(this).val())
  }

  /**
   * Polling function to check when EasyLocation is ready
   */
  function checkEasyLocation() {
    // we are relying on EasyLocation for geo-ip lookups. It saves this data in local storage
    var locationDataRaw = getStoredValue('geoip-location')
    if (locationDataRaw) {
      var locationData = JSON.parse(locationDataRaw)
      var suggestions = getSuggestions(locationData.value)

      if (suggestions !== false) {
        if (suggestions.length) {
          showSuggestions(suggestions)
        } else {
          showUnsupported()
        }
      }

    } else {
      setTimeout(checkEasyLocation, 300)
    }
  }

  /**
   * The main function call
   */
  $(function() {
    // get all the region and locale data
    // the source of the data is the footer links for all regions/languages
    $('#regionLocaleData').find('.region-locale-data-link').each(function(index, element) {
      var $element = $(element)
      var countryCode = $element.attr('data-country')
      var locale = $element.attr('data-locale')

      if (!countryCode || !locale) {
        return
      }
      countryCode = countryCode.toLowerCase()
      locale = locale.toLowerCase()

      // in case the locale is a sub locale, like fr-CA or en-GB
      var language = getLanguage(locale)

      if (typeof regionLocaleData[countryCode] === 'undefined') {
        regionLocaleData[countryCode] = []
      }
      regionLocaleData[countryCode].push({
        countryCode: countryCode,
        language: language,
        locale: locale,
        href: $element.attr('href'),
        label: $element.html(),
        default: false
      })
    })

    // get current store data
    $locationBanner = $('#locationBanner')
    var storeLocale = $locationBanner.attr('data-current-locale')
    var storeLanguage = getLanguage(storeLocale)
    var currentCountryCode = $locationBanner.attr('data-current-store')

    if (currentCountryCode) {
      currentCountryCode = currentCountryCode.toLowerCase()
    }
    if (storeLocale) {
      storeLocale = storeLocale.toLowerCase()
    }

    storeData = {
      countryCode: currentCountryCode,
      locale: storeLocale,
      language: storeLanguage
    }

    // check for any previous actions
    if (!hasDismissedBanner()) {
      // check for the easylocation service
      setTimeout(checkEasyLocation, 300)
    }
  })

})();
